module.exports = __webpack_public_path__ + "static/Daniel Garay-571ddd7200e5f059c4aa5350415f5431.jpg";